import over from 'ramda/es/over';
import lensProp from 'ramda/es/lensProp';
import dissoc from 'ramda/es/dissoc';
import filter from 'ramda/es/filter';

import {
  POLLS_REQUEST,
  POLLS_SUCCESS,
  POLLS_FAILURE,
  POLLS_MAKE_INVALIDATE,
  NEW_POLL_REQUEST,
  NEW_POLL_SUCCESS,
  NEW_POLL_FAILURE,
} from '../../actions/fund/polls';

import {
  EDIT_POLL_REQUEST_SUCCESS,
  EDIT_POLL_CANCEL_SUCCESS,
  POLL_PUBLISH_SUCCESS,
  POLL_PAUSE_SUCCESS,
  UPDATE_POLL_SUCCESS,
  VOTE_SUCCESS,
  POLL_DELETE_SUCCESS,
} from '../../actions/fund/poll';

const defaultState = {
  loading: false,
  didInvalidate: true,
  isSending: false,
  data: {},
  keys: [],
  hasOwn: false,
  err: '',
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    /*
    *  PAYLOAD: undefined
    */
    case POLLS_MAKE_INVALIDATE: {
      return {
        ...state,
        didInvalidate: true,
      };
    }

    /*
    *  PAYLOAD: undefined
    */
    case POLLS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    /*
    *  PAYLOAD: Object
    */
    case POLLS_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        didInvalidate: false,
      };
    }

    /*
    *  PAYLOAD: Object {err: String}
    */
    case POLLS_FAILURE: {
      return {
        ...state,
        loading: false,
        err: action.payload.err,
        didInvalidate: false,
      };
    }

    /*
    *  PAYLOAD: Object
    */
    case NEW_POLL_REQUEST: {
      return {
        ...state,
        isSending: true,
      };
    }

    /*
    *  PAYLOAD: Object
    */
    case NEW_POLL_SUCCESS: {
      return {
        ...state,
        keys: [...state.keys, action.payload.keys[0]],
        data: { ...state.data, ...action.payload.data },
        hasOwn: true,
        isSending: false,
      };
    }

    /*
    *  PAYLOAD: Object {err: String}
    */
    case NEW_POLL_FAILURE: {
      return {
        ...state,
        isSending: false,
        err: action.payload.err,
      };
    }

    /*
    * При успешных запросах на изменение текущего опроса, так же меняем данные в списке опросов.
    */
    case EDIT_POLL_REQUEST_SUCCESS:
    case EDIT_POLL_CANCEL_SUCCESS:
    case POLL_PAUSE_SUCCESS:
    case POLL_PUBLISH_SUCCESS:
    case VOTE_SUCCESS:
    case UPDATE_POLL_SUCCESS: {
      const pollId = parseInt(action.payload.id, 10);
      if (state.data[pollId]) {
        return {
          ...state,
          data: over(lensProp(pollId), props => ({
            ...props,
            title: action.payload.title,
            status: action.payload.status,
            endsAt: action.payload.endsAt,
          }), state.data),
        };
      }
      return state;
    }

    case POLL_DELETE_SUCCESS: {
      const pollId = parseInt(action.payload, 10);
      if (state.data[pollId]) {
        return {
          ...state,
          data: dissoc(pollId, state.data),
          keys: filter(item => (item !== pollId), state.keys),
        };
      }
      return state;
    }

    default:
  }

  return state;
}
